/**
 * TopBar
 * -------
 * Mobile-only (<768px) top bar. Renders the Carbon Clear wordmark and a
 * hamburger button that opens the mobile nav sheet.
 *
 * Desktop/tablet users never see this — the sidebar handles everything.
 */
import React from "react";
import { MenuIcon } from "lucide-react";
import { cn } from "@/lib/utils";

interface TopBarProps {
  onOpenMenu: () => void;
}

const TopBar: React.FC<TopBarProps> = ({ onOpenMenu }) => (
  <header
    className={cn(
      "md:hidden sticky top-0 z-30 flex h-14 items-center gap-3 px-4",
      "bg-background border-b border-border",
    )}
  >
    <button
      type="button"
      onClick={onOpenMenu}
      aria-label="Open navigation menu"
      className={cn(
        "inline-flex h-10 w-10 items-center justify-center rounded-xl",
        "text-foreground hover:bg-muted transition-colors",
        "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring",
      )}
    >
      <MenuIcon size={20} aria-hidden="true" />
    </button>
    <img
      src="/codeClearLogo.svg"
      alt="CodeClear"
      className="h-7 object-contain"
    />
  </header>
);

export default TopBar;
